import { chartPointToPixel } from "../coordinateUtils";
import { createDrawingObject, replaceLastPoint } from "../shared";
export function calculateInsidePitchforkGeometry(drawing, scales) {
    const [pivotPoint, leftPoint, rightPoint] = drawing.points;
    if (!pivotPoint || !leftPoint || !rightPoint)
        return null;
    const pivot = chartPointToPixel(pivotPoint, scales);
    const leftSwing = chartPointToPixel(leftPoint, scales);
    const rightSwing = chartPointToPixel(rightPoint, scales);
    // Inside pitchfork: anchors are at 38.2% and 61.8% between pivot and swings
    const innerLeft = {
        x: pivot.x + (leftSwing.x - pivot.x) * 0.382,
        y: pivot.y + (leftSwing.y - pivot.y) * 0.382,
    };
    const innerRight = {
        x: pivot.x + (rightSwing.x - pivot.x) * 0.382,
        y: pivot.y + (rightSwing.y - pivot.y) * 0.382,
    };
    const midpoint = {
        x: (innerLeft.x + innerRight.x) / 2,
        y: (innerLeft.y + innerRight.y) / 2,
    };
    const direction = {
        x: midpoint.x - pivot.x,
        y: midpoint.y - pivot.y,
    };
    const extend = 10000;
    const medianEnd = {
        x: pivot.x + direction.x * extend,
        y: pivot.y + direction.y * extend,
    };
    const upperEnd = {
        x: innerLeft.x + direction.x * extend,
        y: innerLeft.y + direction.y * extend,
    };
    const lowerEnd = {
        x: innerRight.x + direction.x * extend,
        y: innerRight.y + direction.y * extend,
    };
    return {
        pivot,
        leftSwing,
        rightSwing,
        innerLeft,
        innerRight,
        medianLine: { start: pivot, end: medianEnd },
        upperLine: { start: innerLeft, end: upperEnd },
        lowerLine: { start: innerRight, end: lowerEnd },
    };
}
const InsidePitchfork = {
    name: "insidePitchfork",
    createDraft: (startPoint) => createDrawingObject("insidePitchfork", [startPoint, startPoint, startPoint]),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
};
export default InsidePitchfork;
